import './titles-animations.component.js';
// import './border-gradient-hover.component.js';
// import './gradient-first.component.js';
// import './gradient-process.component.js';
// import './gradient-process-actions.component.js';
// import './gradient-bg-bubbles.component.js';
import './card-fill.component.js';
import './btn-fill.component.js';
import './stroke.component.js';

const figureImports = [
  ['#home-first-figure', () => import('./figure-home-first.component.js')],
  ['#main-figure', () => import('./figure-main.component.js')],
  ['#help-figure', () => import('./figure-help.component.js')],
  ['#contact-figure', () => import('./figure-contact.component.js')],
  ['#job-post-figure', () => import('./figure-job-post.component.js')],
  ['#jobs-figure', () => import('./figure-jobs.component.js')],
  ['#about-first-figure', () => import('./figure-about-first.component.js')],
];

const loadedFigures = new Set();

function loadFigureModule(selector, loadModule) {
  if (loadedFigures.has(selector)) {
    return;
  }

  loadedFigures.add(selector);
  loadModule();
}

function initFigureAnimations() {
  if (!('IntersectionObserver' in window)) {
    figureImports.forEach(([selector, loadModule]) => {
      if (document.querySelector(selector)) {
        loadFigureModule(selector, loadModule);
      }
    });

    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        const selector = entry.target.dataset.figureSelector;
        const loadModule = figureImports.find(([itemSelector]) => itemSelector === selector)?.[1];

        if (!selector || !loadModule) {
          return;
        }

        loadFigureModule(selector, loadModule);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '200px 0px',
      threshold: 0.01,
    }
  );

  figureImports.forEach(([selector, loadModule]) => {
    const figureCanvas = document.querySelector(selector);

    if (!figureCanvas) {
      return;
    }

    figureCanvas.dataset.figureSelector = selector;
    observer.observe(figureCanvas);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFigureAnimations, { once: true });
} else {
  initFigureAnimations();
}
